import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDateAug = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		fill: "none",
		viewBox: "0 0 32 32",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsx("g", {
			id: `${__svgrId}-Date Icons`,
			children: /* @__PURE__ */ _jsx("g", {
				id: `${__svgrId}-Icon / Date / August`,
				children: /* @__PURE__ */ _jsxs("g", {
					id: `${__svgrId}-Icons`,
					children: [
						/* @__PURE__ */ _jsx("rect", {
							height: 24.9624,
							id: `${__svgrId}-Rectangle 61`,
							stroke: "white",
							strokeLinejoin: "round",
							strokeWidth: 2.5,
							style: { fill: "var(--sticker-pastel,#FFC98E)" },
							width: 22.4432,
							x: 4.6789,
							y: 3.9967
						}),
						/* @__PURE__ */ _jsx("rect", {
							height: 22.4624,
							id: `${__svgrId}-Rectangle 59`,
							strokeLinejoin: "round",
							strokeWidth: 1.5,
							style: {
								fill: "var(--sticker-pastel,#FFC98E)",
								stroke: "var(--sticker-dark,#9A6528)"
							},
							width: 19.9432,
							x: 5.9289,
							y: 5.2468
						}),
						/* @__PURE__ */ _jsx("rect", {
							fill: "white",
							height: 12.9712,
							id: `${__svgrId}-Rectangle 60`,
							strokeLinejoin: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#9A6528)" },
							width: 19.9432,
							x: 5.9311,
							y: 14.7382
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M7.6925 12.8961 L9.7245 7.2961 L11.1725 7.2962 L13.2125 12.8962 L11.8764 12.8961 L11.4844 11.7361 L9.4045 11.7362 L9.0045 12.8961 L7.6925 12.8961 Z M9.7565 10.7282 L11.1404 10.7281 L10.4365 8.6881 L9.7565 10.7282 Z M15.5253 12.9921 C15.0027 12.9922 14.5733 12.8881 14.2374 12.6801 C13.9014 12.4721 13.6533 12.1948 13.4934 11.8481 C13.3333 11.5015 13.2534 11.1175 13.2533 10.6961 L13.2534 7.2961 L14.5093 7.2962 L14.5094 10.7041 C14.5094 11.0668 14.5973 11.3468 14.7733 11.5441 C14.9494 11.7361 15.208 11.8321 15.5494 11.8321 C15.8854 11.8321 16.144 11.7361 16.3254 11.5441 C16.512 11.3469 16.6054 11.0668 16.6054 10.7042 L16.6053 7.2961 L17.8614 7.2961 L17.8613 10.6961 C17.8613 11.1334 17.7893 11.4988 17.6454 11.7922 C17.5013 12.0855 17.312 12.3201 17.0773 12.4962 C16.848 12.6721 16.5947 12.8001 16.3174 12.8801 C16.0454 12.9548 15.7814 12.9921 15.5253 12.9921 Z M20.9818 12.9922 C20.4539 12.9921 19.9899 12.8748 19.5899 12.6401 C19.1951 12.4002 18.8885 12.0668 18.6699 11.6402 C18.4512 11.2134 18.3418 10.7148 18.3419 10.1441 C18.3418 9.5948 18.4485 9.0988 18.6619 8.6561 C18.8805 8.2134 19.2005 7.8615 19.6218 7.6001 C20.0485 7.3334 20.5739 7.2001 21.1979 7.2001 C21.8699 7.2002 22.4245 7.3601 22.8618 7.6802 C23.3045 8.0001 23.5926 8.4454 23.7258 9.0161 L22.3338 9.0161 C22.2485 8.8081 22.1125 8.6482 21.9258 8.5362 C21.7392 8.4188 21.4965 8.3601 21.1979 8.3602 C20.8939 8.3601 20.6245 8.4321 20.3899 8.5761 C20.1552 8.7148 19.9685 8.9175 19.8298 9.1842 C19.6965 9.4508 19.6299 9.7762 19.6299 10.1601 C19.6298 10.5334 19.6965 10.8482 19.8298 11.1042 C19.9632 11.3602 20.1419 11.5521 20.3659 11.6801 C20.5952 11.8081 20.8485 11.8721 21.1259 11.8722 C21.5259 11.8721 21.8379 11.7868 22.0619 11.6161 C22.2858 11.4401 22.4406 11.2135 22.5259 10.9362 L20.9018 10.9361 L20.9018 9.8481 L23.8299 9.8482 L23.8299 12.8961 L22.6699 12.8961 L22.5739 12.2801 C22.4085 12.5095 22.1952 12.6855 21.9338 12.8082 C21.6779 12.9308 21.3605 12.9921 20.9818 12.9922 Z",
							id: `${__svgrId}-AUG`,
							style: { fill: "var(--sticker-dark,#9A6528)" }
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 34`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 9.942,
							x2: 9.942,
							y1: 15.3986,
							y2: 27.0677
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 38`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 13.9199,
							x2: 13.9198,
							y1: 15.3984,
							y2: 27.0676
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 36`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 6.5944,
							x2: 25.153,
							y1: 19.1321,
							y2: 19.1321
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 37`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 6.5949,
							x2: 25.1535,
							y1: 23.0835,
							y2: 23.0835
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 35`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 17.7503,
							x2: 17.7503,
							y1: 15.3984,
							y2: 27.0675
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 39`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 21.7954,
							x2: 21.7954,
							y1: 15.3985,
							y2: 27.0676
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M12.8152 4.3477 L12.8151 6.1461",
							id: `${__svgrId}-Line 40`,
							strokeLinecap: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#9A6528)" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M19.2456 4.3477 L19.2456 6.146",
							id: `${__svgrId}-Line 41`,
							strokeLinecap: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#9A6528)" }
						})
					]
				})
			})
		})
	});
};
export default SvgDateAug;
